import { USER_ROLES } from './constants';

const COLUMNS = [
    {
        title: '_name_',
        key: 'name',
        format: 'name',
        isNested: false,
        isKey: true,
        dataSort: true
    }, {
        title: '_opening_balance_',
        key: 'initialBalance',
        format: 'openingBalance',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_turnover_',
        key: 'turnover',
        format: 'turnover',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_salary_',
        key: 'salary',
        format: 'salary',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_final_balance_',
        key: 'finalBalance',
        format: 'finalBalance',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_date_',
        key: 'date',
        format: 'date',
        isNested: false,
        isKey: true,
        dataSort: true
    }, {
        title: '_profit_',
        key: 'profit',
        format: 'profit',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_expense_',
        key: 'expense',
        format: 'expense',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_input_',
        key: 'input',
        format: 'input',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_output_',
        key: 'output',
        format: 'output',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_order_id_',
        key: 'orderId',
        format: 'orderId',
        isNested: false,
        isKey: true,
        dataSort: true
    }, {
        title: '_partner_',
        key: 'partner',
        format: 'partner',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_comments_',
        key: 'comment',
        format: 'comment',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_opening_balance_',
        key: 'initialRest',
        format: 'initialRest',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_rest_',
        key: 'rest',
        format: 'rest',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_delivery_price_label_',
        key: 'deliveryPrice',
        format: 'deliveryPrice',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_payment_type_',
        key: 'paymentType',
        format: 'paymentType',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_terminal_output_',
        key: 'terminalOutput',
        format: 'terminalOutput',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_deactivation_date_',
        key: 'deactivationDate',
        format: 'deactivationDate',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_provided_transport_',
        key: 'providedTransport',
        format: 'providedTransport',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_transport_provided_date_',
        key: 'transportProvidedDate',
        format: 'date',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_fund_deposit_',
        key: 'fundDeposit',
        format: 'boolean',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_charging_amount_',
        key: 'chargingAmount',
        format: 'chargingAmount',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_total_charged_',
        key: 'input',
        format: 'number',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_first_charge_',
        key: 'firstCharge',
        format: 'date',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_last_charge_',
        key: 'lastCharge',
        format: 'date',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_charging_balance_',
        key: 'chargingBalance',
        format: 'chargingBalance',
        isNested: false,
        isKey: false,
        dataSort: true
    },
    {
        title: '_bag_',
        key: 'bag',
        format: 'bag',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_bag_provided_date_',
        key: 'bagProvidedDate',
        format: 'date',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_pos_terminal_id_',
        key: 'posTerminalId',
        format: 'posTerminalId',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_pos_provided_date_',
        key: 'posProvidedDate',
        format: 'date',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_fund_deposit_',
        key: 'salaryFundDeposit',
        format: 'boolean',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_charging_amount_',
        key: 'salaryChargingAmount',
        format: 'chargingAmount',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_charging_balance_',
        key: 'salaryChargingBalance',
        format: 'chargingBalance',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_fund_deposit_',
        key: 'saveDeposit',
        format: 'boolean',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_charging_amount_',
        key: 'saveDepositAmount',
        format: 'chargingAmount',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_deposit_total_',
        key: 'saveDepositTotal',
        format: 'chargingAmount',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_available_debt_',
        key: 'availableDebt',
        format: 'chargingAmount',
        isNested: false,
        isKey: false,
        dataSort: true
    }, {
        title: '_payed_salary_',
        key: 'payedSalary',
        format: 'chargingAmount',
        isNested: false,
        isKey: false,
        dataSort: true
    }
];

export default {
    transactionTypes: {
        INPUT: 1,
        OUTPUT: 2
    },
    balance: {
        [USER_ROLES.ACCOUNTANT]: [0, 1, 2, 3, 4, 38],
        [USER_ROLES.SUPER_ADMIN]: [0, 1, 2, 3, 4, 38],
        [USER_ROLES.ADMIN]: [0, 1, 2, 3, 4, 38]
    },
    turnover: {
        [USER_ROLES.ACCOUNTANT]: [5, 13, 6, 7, 17, 8, 9, 14],
        [USER_ROLES.SUPER_ADMIN]: [5, 13, 6, 7, 17, 8, 9, 14],
        [USER_ROLES.ADMIN]: [5, 13, 6, 7, 17, 8, 9, 14]
    },
    turnoverDetails: {
        [USER_ROLES.ACCOUNTANT]: [10, 16, 11, 8, 15, 9, 12],
        [USER_ROLES.SUPER_ADMIN]: [10, 16, 11, 8, 15, 9, 12],
        [USER_ROLES.ADMIN]: [10, 11, 16, 8, 15, 9, 12]
    },
    materialMeansReport: {
        [USER_ROLES.ACCOUNTANT]: [0, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
        [USER_ROLES.SUPER_ADMIN]: [0, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
        [USER_ROLES.ADMIN]: [0, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]
    },
    distributorSalaryReport: {
        [USER_ROLES.ACCOUNTANT]: [0, 18, 19, 20, 31, 32, 23, 24, 25, 33, 27, 28],
        [USER_ROLES.SUPER_ADMIN]: [0, 18, 19, 20, 31, 32, 23, 24, 25, 33, 27, 28],
        [USER_ROLES.ADMIN]: [0, 18, 19, 20, 31, 32, 23, 24, 25, 33, 27, 28]
    },
    distributorSaveReport: {
        [USER_ROLES.ACCOUNTANT]: [0, 34, 37, 35, 23, 36, 24, 25],
        [USER_ROLES.SUPER_ADMIN]: [0, 34, 37, 35, 23, 36, 24, 25],
        [USER_ROLES.ADMIN]: [0, 34, 35, 37, 23, 36, 24, 25]
    },
    canEdit(role) {
        return (role === USER_ROLES.ACCOUNTANT);
    },
    getColumns(role, tab) {
        const currentTab = this[tab] || {};
        let columns = currentTab[role] || [];
        return columns.map( id => COLUMNS[id]);
    }
};
